import { CurrencyConverter } from '@fiverr-private/futile';
import { currencyFormat, CURRENCY_CODES } from '@fiverr-private/localization';

const currencyConverter = new CurrencyConverter();

/**
 * Format currency
 * @param {number} value Formatting value
 * @returns {string} Formatted currency
 */
export const currencyFormatter = (value) =>
    currencyFormat(value, CURRENCY_CODES.USD, {
        fallbackValue: currencyConverter.convert(value)
    });
